import React from 'react';
import { Typography, Box, Grid, TextField, Theme, Button } from '@mui/material'
import NumberFormatCustom from '../../components/NumberFormatCustom';
import _ from 'lodash';
import { CompanyT, VariablesObj } from '../../types/Company';
import { getDefaultPackingMaterials } from './PackingMaterialsList';
import { copyObject } from '../../utils';
import ButtonLoading from '../../components/ButtonLoading';
import { AxiosInstance } from '../../utils/RequestMethods';
import config from '../../constants/config';

export type IPackingMaterialsTabProps = {
    company: CompanyT,
    updateCompany(company: CompanyT): void
}

const PackingMaterialsTab: React.FC<IPackingMaterialsTabProps> = (props) => {
    const [variables, setVariables] = React.useState(VariablesObj)
    const defaultPackingMaterials = getDefaultPackingMaterials()
    const [lineItems, setLineItems] = React.useState(defaultPackingMaterials);
    // const classes = useStyles()
    const [isReady, setIsReady] = React.useState(false)



    React.useEffect(() => {
        setIsReady(true)
    }, []);

    React.useEffect((): void => {
        if (props.company && props.company.packingMaterials) {
            setLineItems(_.merge(defaultPackingMaterials, props.company.packingMaterials))
        }
    }, [props.company])


    const handleChange = (index: number, key: string, value: any) => {
        let cloneItems = copyObject(lineItems)
        cloneItems[index][key] = value
        setLineItems(cloneItems)
    };


    /**
    *
    * @returns
    */
    const save = async (): Promise<string> => {

        // const paramsVariables = {}
        // Object.keys(variables).map((key) => {
        //     paramsVariables[key] = variables[key]
        // })

        const params = {
            "packingMaterials": lineItems,
        }
        return AxiosInstance.post(`${config.url.companies}/${props.company.id}`, params).then((res) => {

            if (res && (res.status || res.status == 200)) {
                let msg = 'Materials saved.'

                if (res.data) {
                    props.updateCompany(res.data)
                }
                return msg
            } else {
                let msg = 'Materials prices could NOT be saved.'
                throw new Error(msg);

            }
        }).catch((error) => {
            throw error

        })
    }


    const packingMaterialsForm = (): Array<JSX.Element> => {
        let arr = []
        if (!_.isArray(lineItems)) {
            return arr
        }

        lineItems.map((item, index) => {
            arr.push(
                <Grid
                    item
                    xs={12}
                    key={index}
                >
                    <Box style={{ display: 'grid', gridTemplateColumns: 'minmax(100px, 1fr) 3fr' }}>
                        <Box display="flex" alignItems="flex-end">
                            <Typography>{item.label}</Typography>
                        </Box>
                        <TextField
                            variant="standard"
                            fullWidth
                            value={item.rate}
                            label="Rate"
                            InputProps={{
                                inputComponent: NumberFormatCustom as any,
                                inputProps: {
                                    fixedDecimalScale: true,
                                    decimalScale: 2,
                                    mask: "_",
                                }

                            }}
                            onChange={(event: any) => {
                                let value = event.target.value
                                handleChange(index, "rate", value)
                            }}
                        />
                    </Box>
                </Grid>
            )
        })
        return arr
    }


    return (
        <Grid container spacing={3}>
            {packingMaterialsForm()}
            <Grid item xs={12} >
                <ButtonLoading
                    className="ml-1"
                    customButton={Button}
                    customButtonProps={{
                        // fullWidth: true,
                        variant: "contained",
                        color: "success"
                    }}
                    onClickFetching={save}
                >
                    Save
                </ButtonLoading>
            </Grid>
        </Grid>
    );
}

export { PackingMaterialsTab };
